import React, { Component } from "react";

class CalculatorInput extends Component {
  render() {
    return (
      <div className="calculator--form-group">
        <label className="calculator--input-label" style={{ width: '100%' }}>{this.props.label}</label>
        <input
          type="number"
          className={`${ this.props.touched ? 
            (this.props.errorClass ? "is-valid" : "is-invalid") : ""
          }`}
          value={this.props.value}
          onChange={e => this.props.onChangeHandler(e, this.props.paramId)}
          onBlur={e => this.props.onBlurHandler(this.props.paramId)}
          placeholder={this.props.placeholder}
        />
        {this.props.touched && !this.props.errorClass && !this.props.valid &&      (<p className="calculator--form-error">{this.props.errorText}</p>)}
      </div>
    );
  }
}

export default CalculatorInput;
